/**
 * /admin/diagnostics — Admin "운영 점검" 화면
 *
 * 여러 점검 이슈(현재는 Cafe24 FBE 픽셀 중복)를 한 페이지에서 보여준다.
 * 부모 `/admin` 라우트가 인증 가드와 `AdminLayout` 을 담당하므로, 이 파일은
 * URL 만 정의하고 실제 UI 는 `DiagnosticsSection` 에 위임한다.
 */
import { createFileRoute } from '@tanstack/react-router'
import { DiagnosticsSection } from '@/features/admin/DiagnosticsSection'

export const Route = createFileRoute('/admin/diagnostics')({
  component: DiagnosticsSection,
})
